export const SET_LAWS_MY_FAV_FETCHING = 'SET_LAWS_MY_FAV_FETCHING';
export const SET_LAWS_MY_FAV = 'SET_LAWS_MY_FAV';
export const SET_LAWS_MY_FAV_ERROR = 'SET_LAWS_MY_FAV_ERROR';
export const CLEAN_LAWS_MY_FAV = 'CLEAN_LAWS_MY_FAV';
export const ABORT_LAWS_MY_FAV_REQUEST = 'ABORT_LAWS_MY_FAV_REQUEST';
export const RESET_LAWS_MY_FAV_FETCHING = 'RESET_LAWS_MY_FAV_FETCHING';



// WEBPACK FOOTER //
// ./src/redux_related/lawsMyFavorites/actions.js